// @generated by protobuf-ts 2.11.1
// @generated from protobuf file "account.proto" (package "account", syntax proto3)
// tslint:disable
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { AccountService } from "./account";
import type { DeleteAccountResponse } from "./account";
import type { DeleteAccountRequest } from "./account";
import type { UpdateAccountResponse } from "./account";
import type { UpdateAccountRequest } from "./account";
import type { CreateAccountResponse } from "./account";
import type { CreateAccountRequest } from "./account";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { GetAllAccountsResponse } from "./account";
import type { GetAllAccountsRequest } from "./account";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service account.AccountService
 */
export interface IAccountServiceClient {
    /**
     * @generated from protobuf rpc: GetAllAccounts
     */
    getAllAccounts(input: GetAllAccountsRequest, options?: RpcOptions): UnaryCall<GetAllAccountsRequest, GetAllAccountsResponse>;
    /**
     * @generated from protobuf rpc: CreateAccount
     */
    createAccount(input: CreateAccountRequest, options?: RpcOptions): UnaryCall<CreateAccountRequest, CreateAccountResponse>;
    /**
     * @generated from protobuf rpc: UpdateAccount
     */
    updateAccount(input: UpdateAccountRequest, options?: RpcOptions): UnaryCall<UpdateAccountRequest, UpdateAccountResponse>;
    /**
     * @generated from protobuf rpc: DeleteAccount
     */
    deleteAccount(input: DeleteAccountRequest, options?: RpcOptions): UnaryCall<DeleteAccountRequest, DeleteAccountResponse>;
}
/**
 * @generated from protobuf service account.AccountService
 */
export class AccountServiceClient implements IAccountServiceClient, ServiceInfo {
    typeName = AccountService.typeName;
    methods = AccountService.methods;
    options = AccountService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * @generated from protobuf rpc: GetAllAccounts
     */
    getAllAccounts(input: GetAllAccountsRequest, options?: RpcOptions): UnaryCall<GetAllAccountsRequest, GetAllAccountsResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetAllAccountsRequest, GetAllAccountsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CreateAccount
     */
    createAccount(input: CreateAccountRequest, options?: RpcOptions): UnaryCall<CreateAccountRequest, CreateAccountResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<CreateAccountRequest, CreateAccountResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateAccount
     */
    updateAccount(input: UpdateAccountRequest, options?: RpcOptions): UnaryCall<UpdateAccountRequest, UpdateAccountResponse> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateAccountRequest, UpdateAccountResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: DeleteAccount
     */
    deleteAccount(input: DeleteAccountRequest, options?: RpcOptions): UnaryCall<DeleteAccountRequest, DeleteAccountResponse> {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept<DeleteAccountRequest, DeleteAccountResponse>("unary", this._transport, method, opt, input);
    }
}
